import type { Language } from "./i18n"

// Mapping from full language names (backend format) to language codes (frontend format)
const fullNameToCodeMap: Record<string, Language> = {
  english: "en",
  deutsch: "de",
  german: "de",
  français: "fr",
  french: "fr",
  persian: "fa",
  farsi: "fa",
  فارسی: "fa",
  spanish: "es",
  español: "es",
}

// Mapping from language codes to full language names (backend format)
const codeToFullNameMap: Record<Language, string> = {
  en: "english",
  de: "deutsch",
  fr: "french",
  fa: "persian",
  es: "spanish",
}

/**
 * Convert full language name from backend to language code
 * Handles case-insensitive matching
 */
export function fullLanguageNameToCode(name: string): Language {
  if (!name) return "en"
  
  const normalizedName = name.toLowerCase().trim()
  return fullNameToCodeMap[normalizedName] || "en"
}

/**
 * Convert language code to full language name for backend
 */
export function languageCodeToFullName(code: Language): string {
  return codeToFullNameMap[code] || "english"
}

